// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"SliderPreviewPhotoM_swiperContainer__l_Lf8","swiperSlide":"SliderPreviewPhotoM_swiperSlide__2Pi8T"};